module.exports = __webpack_public_path__ + "static/media/classicsauce.124eac84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/flavor/classicsauce.jpg
// module id = 143
// module chunks = 0